import { render } from "./ProvinceTaskAttachmentModal.vue?vue&type=template&id=54f30910&scoped=true&ts=true"
import script from "./ProvinceTaskAttachmentModal.ts?vue&type=script&lang=ts"
export * from "./ProvinceTaskAttachmentModal.ts?vue&type=script&lang=ts"

import "./ProvinceTaskAttachmentModal.scss?vue&type=style&index=0&id=54f30910&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54f30910"]])

export default __exports__